var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserYellow16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_User_Yellow-16px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_User_Yellow-16px",
    fill: "#FFCD00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Eraklient"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,10 L5,10 C2.238,10 0,12.238 0,15 C0,15.5530005 0.447,16 1,16 L11,16 C11.553,16 12,15.5530005 12,15 C12,12.238 9.762,10 7,10 Z M6,8 C7.657,8 9,6.657 9,5 L9,3 C9,1.343 7.657,0 6,0 C4.343,0 3,1.343 3,3 L3,5 C3,6.657 4.343,8 6,8 Z",
    id: "Icon_User_Gray-16px"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserYellow16Px);
export default __webpack_public_path__ + "static/media/Icon_User_Yellow-16px.86478e78c80b8cd9b80cc364a0757dbf.svg";
export { ForwardRef as ReactComponent };